import { DialogRef } from '@angular/cdk/dialog';
import {
  ChangeDetectionStrategy,
  Component,
  CUSTOM_ELEMENTS_SCHEMA,
  inject,
} from '@angular/core';

@Component({
  selector: 'directory-portal-video-dialog',
  changeDetection: ChangeDetectionStrategy.OnPush,
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  template: `
    <section
      class="max-w-3xl w-[95vw] sm:w-[50vw] mx-auto p-6 bg-white rounded-md shadow-md text-gray-800 space-y-2">
      <div>
        <h2
          class="inline-flex items-center mb-4 text-xl font-semibold text-gray-900">
          <img
            class="w-auto object-fill mix-blend-multiply h-8 mr-2"
            src="logo.jpg"
            alt="logo" />
        </h2>
      </div>

      <div class="py-4">
        <div class="aspect-video w-full">
          <wistia-player
            media-id="fl4hntm6lf"
            aspect="1.7777777777777777"></wistia-player>
        </div>
      </div>

      <div class="w-full flex justify-center">
        <button
          (click)="close()"
          class="w-full lg:w-max px-4 py-2.5 text-base font-medium text-center text-gray-800 bg-white border border-gray-200 rounded-lg hover:bg-gray-100"
          i18n="@@common.close">
          Close
        </button>
      </div>
    </section>
  `,
})
export class VideoDialogComponent {
  private readonly dialogRef = inject(DialogRef);

  close(): void {
    this.dialogRef.close();
  }
}
